import { render, staticRenderFns } from "./dialogueModel.vue?vue&type=template&id=2fffb66e&scoped=true&"
import script from "./dialogueModel.vue?vue&type=script&lang=js&"
export * from "./dialogueModel.vue?vue&type=script&lang=js&"
import style0 from "./dialogueModel.vue?vue&type=style&index=0&id=2fffb66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffb66e",
  null
  
)

export default component.exports